import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
	name: 'age',
	standalone: true
})
export class AgePipe implements PipeTransform {
	transform(dateString: Date | string | null): number {
		if (dateString == null) {
			return 0;
		}

		const today = moment(new Date());
		const birthDate = moment(new Date(dateString));
		const diffInMilliSeconds = today.diff(birthDate);

		if (diffInMilliSeconds <= 0) {
			return 0;
		}

		const duration = moment.duration(diffInMilliSeconds);
		const age = duration.years();

		return age;
	}
}
